export default {
    data:()=>({
        server_errors: {
            title: '',
            description: '',
        },
        btnLoading: false,
        news: {},
    }),
    methods: {
        ValidateForm(){
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.EditItem();
                }else{
                    this.$scrollTo('#scrollTo');
                }
            });
        },
        EditItem(){
            this.btnLoading = true;
            this.$axios.put('edit-news',{
                id: this.news.id,
                title: this.news.title,
                description: this.news.description,
            }).then((res)=>{
                if(res.data.success == true){
                    setTimeout(() => {
                        this.btnLoading = false;
                        this.$emit('close');
                        this.$emit('success');
                        this.$notification.OpenNotification_AddItem_OnSuccess('top-right', 'dark', 3000);
                        this.$router.push({name: 'list.news'});
                    }, 300);
                }
            }).catch((error)=>{
                this.btnLoading = false;
                this.$scrollTo('#scrollTo');
                if(error.response.status == 422){
                    var obj = error.response.data.errors;       // ໃຊ້ການລູບຂໍ້ມູນເພາະວ່າຂໍ້ມູນ errors ທີ່ສົ່ງມາຈາກ Server ນັ້ນເປັນ Array Object
                    for (let [key, value] of Object.entries(obj)) {
                        this.server_errors[key] = value[0];
                    }
                }
            });
        },

        FetchUsers(){
            this.$axios.get('list-news/' + this.$route.params.id).then((res)=>{
                this.news = res.data.news;
            }).catch(()=>{});
        },
    }
}